import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { theme } from "../../Assets/Theme/theme";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import logo from "../../Assets/Images/logo.png";
import login_bg from "../../Assets/Images/login-bg.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function NewPwd() {
    const [inputValues, setInputValues] = useState({
        password: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState([])
    const [isHovered, setIsHovered] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const { state } = useLocation()

    const handleChange = (field, value) => {
        setInputValues((prevData) => ({ ...prevData, [field]: value }));
    };
    

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/forgot/step3/password`, {
                email: state?.email,
                otp: state?.otp,
                password: inputValues?.password,
                confirmPassword: inputValues?.confirmPassword
            });

            if (response?.data) {
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    style: { backgroundColor: 'orange', color: 'white' },
                });
                navigate("/login");
            } else {
                toast.error("Failed", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                
            }
        } catch (error) {
            setErrors(error?.response?.data?.error)
        } finally {
            setLoading(false);
        }
    };

    const getErrorMessage = (field) => {
        const fieldError = errors?.find((err) => err?.path === field);
        return fieldError?.msg || null;
    };

    const clearErrorMessage = (field) => {
        setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                handleSubmit()
            }
        };

        window.addEventListener("keypress", handleKeyPress);

        return () => {
            window.removeEventListener("keypress", handleKeyPress);
        };
    }, [inputValues]);

    return (
        <Box display={"flex"} overflow={"hidden"}>
            {/* <IconButton
                onClick={() => navigate(-1)}
                sx={{
                    position: "absolute",
                    top: 16,
                    left: 16,
                    color: theme.colors.primary,
                }}
            >
                <ArrowBackIcon />
            </IconButton> */}

            {/* Left Section */}
            <Box
                width={"62%"}
                display={"flex"}
                flexDirection={"column"}
                alignContent={"center"}
                justifyContent={"center"}
                sx={{
                    "@media (max-width:900px)": {
                        width: "100%",
                    },
                }}
            >
                <Box marginBottom={5} textAlign={"center"}>
                    <img src={logo} width={80} height={74} />
                </Box>
                <Box textAlign={"center"} marginBottom={3} color={theme.colors.text}>
                    <Typography variant="h5" fontWeight={600}>
                        Reset Password
                    </Typography>

                    <Typography
                        variant="body2"
                        color="#6c757d"
                        textAlign="center"
                        marginBottom={1}
                        marginTop={1}
                        sx={{ fontFamily: "Nunito, sans-serif" }}
                    >
                    Please provide the required details to reset your account password.
                    </Typography>

                </Box>
                <Box
                    width={"60%"}
                    margin={"0 auto"}
                    sx={{
                        "@media (max-width:400px)": {
                            width: "80%",
                        },
                    }}
                >
                    <Box>
                        <TextInput
                            label={"Password"}
                            placeholder={"Enter Your Password..."}
                            type={"password"}
                            name={"password"}
                            onChange={(e) => {
                                handleChange("password", e.target.value)
                                clearErrorMessage("password");
                            }}
                        />
                        {getErrorMessage("password") && (
                            <Box color="red" mb={2}>
                                {getErrorMessage("password")}
                            </Box>
                        )}
                        <TextInput
                            label={"Confirm Password"}
                            placeholder={"Enter Your Confirm Password..."}
                            type={"password"}
                            name={"password"}
                            onChange={(e) => {
                                handleChange("confirmPassword", e.target.value)
                                clearErrorMessage("confirmPassword");
                            }}
                        />
                        {getErrorMessage("confirmPassword") && (
                            <Box color="red" mb={2}>
                                {getErrorMessage("confirmPassword")}
                            </Box>
                        )}
                        <CustomButton onClick={handleSubmit}>
                            {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Reset Password'}
                        </CustomButton>
                    </Box>
                </Box>
            </Box>

            {/* Right Section */}
            <Box
                width="35%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    "@media (max-width: 900px)": {
                        display: "none",
                    },
                    "@media (min-width: 900px) and (max-width: 1200px)": {
                        height: "20vh",
                    },
                    "@media (min-width: 900px)": {
                        height: "90vh",
                    },
                }}
            >
                <img
                    src={login_bg}
                    alt="Login Background"
                    style={{ width: "100%", height: "100%" }}
                />
            </Box>
        </Box>
    );
}

export default NewPwd;
